import { useCallback, useEffect, useState } from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { spassuCodeApiRef } from '../../api';
import type { ScmProviderDescriptor } from '../../api/types';
import { useAsyncOptions } from './useAsyncOptions';

export function useCreationProviders(open: boolean) {
  const api = useApi(spassuCodeApiRef);
  const query = useAsyncOptions(
    useCallback(() => api.listScmProviders(), [api]),
    open,
  );
  const [selected, select] = useState<ScmProviderDescriptor | null>(null);
  useEffect(() => {
    select(previous => {
      if (query.status !== 'success') return null;
      return (
        query.items.find(item => item.id === previous?.id) ??
        query.items.find(item => item.id === 'azure-devops') ??
        query.items[0] ??
        null
      );
    });
  }, [query.items, query.status]);
  return {
    query,
    selected,
    select,
    isAzure: selected?.id === 'azure-devops',
    isAgnostic: !!selected && selected.id !== 'azure-devops',
  };
}
